export interface SSOUrlParameters {  
  ContractorId: string;
  ContactId: string;
  Type?: string,
  CreditsUrls?: string;
  SSOUrl?: string;
}
